import { Navigate, Route } from 'react-router-dom';

import FindPasswordPage from '../pages/auth/findPw/FindPasswordPage';
import ReverificationPage from '../pages/auth/reverification/ReverificationPage';
import SignUpPage from '../pages/auth/signup/SignUpPage';

import { createLazyRoute } from './utils/createLazyRoute';

/**
 * 인증 관련 라우트
 */
export const authRoutes = (
  <>
    <Route path="login" {...createLazyRoute(() => import('../pages/auth/LoginPage'))} />

    <Route path="signup" element={<SignUpPage />}>
      <Route path="agree" {...createLazyRoute(() => import('../pages/auth/signup/AgreementsPage'))} />
      <Route path="hospital" {...createLazyRoute(() => import('../pages/auth/signup/HospitalPage'))} />
      <Route path="account" {...createLazyRoute(() => import('../pages/auth/signup/AccountsPage'))} />
      <Route path="" element={<Navigate to={`/`} replace />} />
    </Route>

    <Route path="re-verification" element={<ReverificationPage />} />

    <Route path="findpw" element={<FindPasswordPage />}>
      <Route path="email" {...createLazyRoute(() => import('../pages/auth/findPw/EmailInputPage'))} />
      <Route path="verification" {...createLazyRoute(() => import('../pages/auth/findPw/IdentityVerificationPage'))} />
      <Route path="reset" {...createLazyRoute(() => import('../pages/auth/findPw/PasswordResetPage'))} />
      <Route path="" element={<Navigate to={`/`} replace />} />
    </Route>

    <Route path="print/stim" {...createLazyRoute(() => import('../pages/stim/PrintStimAgreementPage'))} />
  </>
);
